import { useEffect } from 'react';
import { useEntitlements } from '../plan.js';

const KEY = 'secretario.palco.ligado';

function remembered(): boolean {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * A Início em palco está liberada para esta pessoa? Quem decide é o servidor;
 * a última resposta fica lembrada no aparelho para a tela não trocar de cara
 * a cada abertura enquanto a resposta nova não chega.
 */
export function useStageOn(enabled = true): boolean {
  const entitlementsQ = useEntitlements(enabled);
  const live = entitlementsQ.data?.features.stage?.enabled;
  useEffect(() => {
    if (live === undefined) return;
    try {
      window.localStorage.setItem(KEY, live ? '1' : '0');
    } catch {
      /* sem armazenamento: pergunta ao servidor a cada abertura */
    }
  }, [live]);
  return live ?? remembered();
}
